import { Constants } from "constants/Constants";
import { Language } from "types/Language";
import { getStoredData } from "./fnAsyncStorage";

type Props = {
  importType: string;
  isTemplate?: boolean;
  id?: string | number;
  lang?: Language;
};

const exportData = async ({
  importType,
  isTemplate = false,
  id,
  lang,
}: Props) => {
  try {
    if (!isTemplate && !id) {
      throw new Error(
        `La donnée à exporter n'est pas disponible. Veuillez ré-essayer ou contactez le support si l'erreur persiste.`
      );
    }

    const apiUrl = Constants.API_URL;
    const token = await getStoredData("token");

    const headers = new Headers();
    const baseUrl = isTemplate
      ? `${apiUrl}/export/template/${importType}/${lang}`
      : `${apiUrl}/export/${importType}/${lang}/${id}`;

    headers.append("Content-Type", "application/json");

    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }

    const response = await fetch(baseUrl, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Erreur HTTP: ${response.status} - ${errorText}`);
    }

    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = isTemplate ? "template.xlsx" : "export_de_donnees.xlsx";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match) {
        [, filename] = match;
      }
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.error("Erreur lors du téléchargement du fichier :", err);
  }
};

export default exportData;
